var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tb.text)?_c('div',{staticStyle:{"position":"fixed","width":"100%","z-index":"99","min-width":"320px","max-width":"540px"}},[_c('van-notice-bar',{attrs:{"scrollable":"","text":_vm.tb.text,"mode":"closeable","color":"#1989fa","background":"#ecf9ff","left-icon":"info-o"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0b1c1a30","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/fields/NoticeBar.vue
// module id = null
// module chunks = 